import { render } from "./ContentTabungan.vue?vue&type=template&id=e7fafb04&scoped=true"
import script from "./ContentTabungan.vue?vue&type=script&lang=js"
export * from "./ContentTabungan.vue?vue&type=script&lang=js"

import "./ContentTabungan.vue?vue&type=style&index=0&id=e7fafb04&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7fafb04"]])

export default __exports__